import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login/login';
import ForgotPassword from './pages/Login/ForgotPassword';
import OtpLogin from './pages/Login/OtpLogin';
import NewPassword from './pages/Login/NewPassword';
import Home from './pages/Home/home';
import SlPage from './pages/Login/SlPage';
import { Provider } from 'react-redux';
import './bootstrap.min.css';
import './fonts.css';
import store from './store/store';
import { SnackbarProvider } from 'notistack';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AutoLogin from './pages/Login/AutoLogin';
import ScrollTopFunction from './ScrollTopFunction';


function App() {
  return (
    <>
      <ToastContainer />
      <React.StrictMode>
        <Provider store={store}>
          <SnackbarProvider maxSnack={3}>
            <BrowserRouter>
            <ScrollTopFunction/>
              <Routes>
                <Route path='/' element={<Login />} />
                <Route path='/*' element={<Home />} />
								<Route path='/forgot-password' element={<ForgotPassword />} />
								<Route path='/verify-otp' element={<OtpLogin />} />
								<Route path='/new-password' element={<NewPassword />} />
								<Route path='/sl/:id' element={<SlPage />} />
								<Route path='/autologin/:token/:dept' element={<AutoLogin />} />
              </Routes>
            </BrowserRouter>
          </SnackbarProvider>
        </Provider>
      </React.StrictMode>
    </>
  );
}

export default App;
